const MeditationRecourcesList = () => import(/* webpackChunkName 'MeditationRecourcesList' */ '@/components/Astrology/Meditation/MeditationRecource/MeditationRecourcesList/MeditationRecourcesList.vue');
const MeditationCategoriesList = () => import(/* webpackChunkName 'MeditationCategoriesList' */ '@/components/Astrology/Meditation/MeditationCategory/MeditationCategoriesList/MeditationCategoriesList.vue');

export default {
    path: 'meditation',
    name: 'meditation',
    redirect: 'meditation-resources/',
    meta: {
        label: 'Meditation'
    },
    component: {
        name: 'Meditation',
        render(c: any) {
            return c('router-view');
        }
    },
    children: [
        {
            path: 'meditation-resources',
            name: 'meditation-resources',
            meta: {
                // accessLevel: USER_LIST,
                label: 'Recources'
            },
            component: MeditationRecourcesList
        },
        {
            path: 'meditation-categories',
            name: 'meditation-categories',
            meta: {
                // accessLevel: USER_LIST,
                label: 'Categories'
            },
            component: MeditationCategoriesList
        }
    ]
};